// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyBAMNeQpgUrq-7ZL6sl4a-NqT9yTXcPXfQ",
  authDomain: "chat-app-4256d.firebaseapp.com",
  projectId: "chat-app-4256d",
  storageBucket: "chat-app-4256d.appspot.com",
  messagingSenderId: "677774159457",
  appId: "1:677774159457:web:ceb76bdead6031212dc420",
  measurementId: "G-ZLTCEM1ZXH"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebaseApp.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const db = firebaseApp.firestore();
export {auth, provider }
export default db;
